<template>
  <div v-if="totalCount > 100" class="side-menu-pagination-controls">
    <div class="side-menu-pagination-info">
      <span class="side-menu-pagination-text">
        Page <strong>{{ currentPage }}</strong> of <strong>{{ totalPages }}</strong>
        ({{ ((currentPage - 1) * recordsPerPage + 1).toLocaleString() }}-{{ Math.min(currentPage * recordsPerPage, totalCount).toLocaleString() }} of {{ totalCount.toLocaleString() }})
      </span>
    </div>
    <div class="side-menu-pagination-actions">
      <button 
        class="side-menu-pagination-btn side-menu-pagination-btn-first" 
        @click="goToPage(1)"
        :disabled="currentPage === 1 || loading"
        title="First page"
      >
        ««
      </button>
      <button 
        class="side-menu-pagination-btn side-menu-pagination-btn-prev" 
        @click="goToPage(currentPage - 1)"
        :disabled="currentPage === 1 || loading"
        title="Previous page"
      >
        ‹
      </button>
      <div class="side-menu-pagination-jump">
        <input 
          type="number" 
          :min="1" 
          :max="totalPages" 
          v-model.number="jumpToPageInput"
          @keyup.enter="jumpToPage"
          class="side-menu-pagination-jump-input"
          placeholder="Page"
          :disabled="loading"
        />
        <button 
          class="side-menu-pagination-btn side-menu-pagination-btn-jump" 
          @click="jumpToPage"
          :disabled="loading || !jumpToPageInput"
          title="Go to page"
        >
          Go
        </button>
      </div>
      <button 
        class="side-menu-pagination-btn side-menu-pagination-btn-next" 
        @click="goToPage(currentPage + 1)"
        :disabled="currentPage >= totalPages || loading"
        title="Next page"
      >
        ›
      </button>
      <button 
        class="side-menu-pagination-btn side-menu-pagination-btn-last" 
        @click="goToPage(totalPages)"
        :disabled="currentPage >= totalPages || loading"
        title="Last page"
      >
        »»
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SideMenuPagination',
  props: {
    currentPage: {
      type: Number,
      required: true,
      default: 1
    },
    totalCount: {
      type: Number,
      required: true,
      default: 0
    },
    recordsPerPage: {
      type: Number,
      default: 100
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  emits: ['page-changed'],
  data() {
    return {
      jumpToPageInput: null
    };
  },
  computed: {
    totalPages() {
      if (this.totalCount === 0 || this.recordsPerPage === 0) return 1;
      return Math.ceil(this.totalCount / this.recordsPerPage);
    }
  },
  methods: {
    goToPage(page) {
      if (page >= 1 && page <= this.totalPages && page !== this.currentPage) {
        this.$emit('page-changed', page);
        this.jumpToPageInput = null;
      }
    },
    jumpToPage() {
      if (this.jumpToPageInput && this.jumpToPageInput >= 1 && this.jumpToPageInput <= this.totalPages) {
        this.goToPage(this.jumpToPageInput);
      }
    }
  },
  watch: {
    currentPage() {
      // Clear jump input when page changes externally
      this.jumpToPageInput = null;
    },
    jumpToPageInput(newValue) {
      // Validate input - ensure it's within valid range
      if (newValue !== null && newValue !== undefined && newValue !== '') {
        const num = parseInt(newValue);
        if (isNaN(num) || num < 1) {
          this.jumpToPageInput = null;
        } else if (num > this.totalPages) {
          this.jumpToPageInput = this.totalPages;
        }
      }
    }
  }
};
</script>

<style src="./SideMenuPagination.css"></style>
